define.alias("ember-composable-helpers/helpers/toggle", "media/helpers/toggle");